// Initialize sliders that exist on page load
function initSlider(section) {
  const slider = section.querySelector('.slider')
  const prevBtn = section.querySelector('.slider-arrow--prev')
  const nextBtn = section.querySelector('.slider-arrow--next')

  if (!slider || !prevBtn || !nextBtn) return

  // Remove any existing event listeners
  const newPrevBtn = prevBtn.cloneNode(true)
  const newNextBtn = nextBtn.cloneNode(true)
  prevBtn.parentNode.replaceChild(newPrevBtn, prevBtn)
  nextBtn.parentNode.replaceChild(newNextBtn, nextBtn)

  const updateArrows = () => {
    newPrevBtn.setAttribute('aria-hidden', slider.scrollLeft <= 0)
    newNextBtn.setAttribute('aria-hidden', slider.scrollLeft >= slider.scrollWidth - slider.clientWidth)
  }

  newNextBtn.addEventListener('click', () => {
    const itemWidth = slider.querySelector('.slider-item')?.offsetWidth
    if (itemWidth) {
      slider.scrollLeft += itemWidth + parseInt(getComputedStyle(slider).getPropertyValue('--gap') || '0')
    }
  })

  newPrevBtn.addEventListener('click', () => {
    const itemWidth = slider.querySelector('.slider-item')?.offsetWidth
    if (itemWidth) {
      slider.scrollLeft -= itemWidth + parseInt(getComputedStyle(slider).getPropertyValue('--gap') || '0')
    }
  })

  slider.addEventListener('scroll', updateArrows)
  window.addEventListener('resize', updateArrows)
  updateArrows()
}

// Initialize existing sliders
document.querySelectorAll('.section-product-slider').forEach(initSlider)

// Watch for product recommendations being added
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === 'childList' && mutation.addedNodes.length) {
      mutation.addedNodes.forEach((node) => {
        // Check if node is an element and has innerHTML
        if (node.nodeType === Node.ELEMENT_NODE) {
          // Look for slider-wrap either in the node itself or its children
          const sliderWrap = node.classList?.contains('slider-wrap') ? node : node.querySelector('.slider-wrap')
          if (sliderWrap) {
            const section = sliderWrap.closest('.section-product-slider')
            if (section) {
              // Small delay to ensure DOM is fully updated
              setTimeout(() => initSlider(section), 0)
            }
          }
        }
      })
    }
  })
})

// Observe product recommendations sections
document.querySelectorAll('product-recommendations').forEach(recommendations => {
  observer.observe(recommendations, {
    childList: true,
    subtree: true
  })
})